<template>
  <div class="chat-wrapper">
    <div class="chat-main-card">
      <div class="row g-0 h-100">
        <!-- Sidebar de contactos -->
        <div class="col-12 col-md-4 col-lg-3 sidebar-contacts">
          <!-- Perfil del usuario actual -->
          <div class="user-profile p-3 border-bottom-subtle d-flex align-items-center">
            <div class="position-relative mr-3 flex-shrink-0">
              <img :src="user && user.photo_user ? user.photo_user : defaultAvatar" class="avatar" :alt="session_user_name" @error="onAvatarError" />
              <span class="status-badge"></span>
            </div>
            <div class="user-info overflow-hidden">
              <h6 class="user-name mb-0 text-truncate">{{ session_user_name }}</h6>
              <span class="user-status-text">En línea</span>
            </div>
          </div>

          <!-- Filtros de contactos -->
          <div class="px-3 py-2 border-bottom-subtle">
            <div class="d-flex mb-2" style="gap: 8px; overflow-x: auto;">
              <div :class="['filter-pill', selectedRole === 'Todos' ? 'active' : '']" @click="selectedRole = 'Todos'">Todos</div>
              <div :class="['filter-pill', selectedRole === 'Alumno' ? 'active' : '']" @click="selectedRole = 'Alumno'">Alumnos</div>
              <div :class="['filter-pill', selectedRole === 'Profesor' ? 'active' : '']" @click="selectedRole = 'Profesor'">Profesores</div>
            </div>
            
            <!-- Custom Select para Cursos -->
            <div class="custom-select-wrapper position-relative mt-2" style="width: 100%;">
              <div class="custom-select-box p-2 border rounded d-flex align-items-center justify-content-between bg-white border-gray-300" @click="isDropdownOpen = !isDropdownOpen" style="cursor: pointer;">
                <div v-if="selectedCourseItem" class="d-flex align-items-center overflow-hidden">
                  <img v-if="selectedCourseItem.course_image" :src="selectedCourseItem.course_image" class="flex-shrink-0" style="width: 20px; height: 20px; border-radius: 3px; object-fit: cover; margin-right: 12px;" />
                  <div v-else style="width: 20px; height: 20px; border-radius: 3px; background: #eee; margin-right: 12px;" class="flex-shrink-0"></div>
                  <span class="text-truncate" style="font-size: 0.85rem;">{{ selectedCourseItem.course_title }}</span>
                </div>
                <div v-else class="text-muted" style="font-size: 0.85rem;">Todos los cursos</div>
                <!-- SVG Chevron Down to guarantee it renders -->
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-muted"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </div>
              
              <!-- Dropdown Menu -->
              <div v-if="isDropdownOpen" class="custom-select-options shadow position-absolute w-100 bg-white" style="z-index: 10; max-height: 250px; overflow-y: auto; border: 1px solid var(--border-color, #ddd); border-radius: 4px; top: 100%; margin-top: 4px;">
                <div class="custom-select-option p-2 border-bottom-subtle text-muted" @click="selectedCourse = null; isDropdownOpen = false" style="cursor: pointer; font-size: 0.85rem;">
                  Todos los cursos
                </div>
                <div v-for="course in uniqueCourses" :key="course.course_id" class="custom-select-option p-2 border-bottom-subtle d-flex align-items-center" @click="selectedCourse = course.course_id; isDropdownOpen = false" style="cursor: pointer;">
                  <img v-if="course.course_image" :src="course.course_image" class="flex-shrink-0" style="width: 24px; height: 24px; border-radius: 3px; object-fit: cover; margin-right: 12px;" />
                  <div v-else style="width: 24px; height: 24px; border-radius: 3px; background: #eee; margin-right: 12px;" class="flex-shrink-0"></div>
                  <span style="font-size: 0.85rem; line-height: 1.2;">{{ course.course_title }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de chats activos -->
          <div class="chat-list-section p-3">
            <h6 class="section-title mb-3">Chats</h6>
            <div v-if="filteredContacts.length > 0" class="chat-list">
              <div
                v-for="contact in filteredContacts"
                :key="contact.id"
                :class="['chat-item', { active: actualContact && actualContact.id === contact.id }]"
                @click="cambiarChat(idOne, contact.id)"
              >
                <div class="d-flex align-items-center">
                  <div class="position-relative flex-shrink-0" style="margin-right: 16px;">
                    <img :src="contact.photo || defaultAvatar" class="avatar-sm" :alt="contact.name" @error="onAvatarError" />
                    <span class="status-badge-sm"></span>
                  </div>
                  <div class="chat-item-info overflow-hidden">
                    <h6 class="contact-name mb-1 text-truncate">{{ contact.name }}</h6>
                    <p class="last-message mb-0 text-truncate">{{ contact.last_message || 'Sin mensajes anteriores' }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state py-4 text-center">
              <i class="mdi mdi-message-text-outline mb-1" style="color: #A1A1AA; font-size: 28px;"></i>
              <p class="empty-text mb-0">No hay chats que coincidan con tu filtro</p>
            </div>
          </div>

          <!-- Nuevos contactos -->
          <div class="new-contacts-section p-3 border-top-subtle">
            <h6 class="section-title mb-2">Nuevos contactos</h6>
            <div v-if="filteredContacts2.length > 0" class="new-contacts-list">
              <div v-for="contact in filteredContacts2" :key="contact.id" class="contact-item" @click="cambiarChat(idOne, contact.id)">
                <div class="d-flex align-items-center">
                  <img :src="contact.photo || defaultAvatar" class="avatar-sm flex-shrink-0" style="margin-right: 16px;" :alt="contact.name" @error="onAvatarError" />
                  <div class="overflow-hidden">
                    <h6 class="contact-name mb-0 text-truncate">{{ contact.name }}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state py-2 text-center">
              <p class="empty-text mb-0">No hay contactos nuevos que coincidan</p>
            </div>
          </div>
        </div>

        <!-- Área principal del chat -->
        <div class="col-12 col-md-8 col-lg-9 main-chat">
          <div v-if="actualContact && actualContact.id" class="h-100 d-flex flex-column">
            <!-- Encabezado del chat -->
            <div class="chat-header p-3 border-bottom-subtle d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <img :src="actualContact.photo || defaultAvatar" class="avatar-sm flex-shrink-0" style="margin-right: 20px;" :alt="actualContact.name" @error="onAvatarError" />
                <div style="margin-top: -2px;">
                  <h6 class="chat-header-name mb-0">
                    {{ actualContact.name }} {{ actualContact.lastname || '' }}
                  </h6>
                  <span class="chat-header-status text-truncate" style="max-width: 400px; display: inline-block;">
                    <span class="status-dot mr-1"></span>
                    <span v-if="headerContext" class="text-muted">{{ headerContext }}</span>
                    <span v-else class="text-muted">Activo ahora</span>
                  </span>
                </div>
              </div>
            </div>

            <!-- Contenido del chat -->
            <div class="chat-content p-4">
              <div v-if="actualMessageContent.length == 0" class="empty-chat text-center my-auto py-5">
                <i class="mdi mdi-hand-wave-outline mb-2" style="color: var(--primary-color); font-size: 48px;"></i>
                <h5 class="empty-chat-title mb-1">¡Saluda a {{ actualContact.name }}!</h5>
                <p class="empty-chat-sub mb-0">Envía un mensaje para iniciar la conversación</p>
              </div>

              <div v-else class="messages-container">
                <div
                  v-for="message in actualMessageContent"
                  :key="message.id"
                  :class="[
                    'message-group d-flex flex-column',
                    message.transmitter_id == user.id ? 'message-outgoing' : 'message-incoming'
                  ]"
                >
                  <!-- Nombre del remitente -->
                  <span class="sender-name mb-1">
                    {{ message.transmitter_id == user.id ? 'Tú' : actualContact.name }}
                  </span>

                  <!-- Burbuja de mensaje -->
                  <div class="message-bubble shadow-sm">
                    <div class="message-text">
                      {{ message.message }}
                    </div>
                  </div>

                  <!-- Estampa de tiempo -->
                  <span class="message-time mt-1">
                    {{ moment(message.created_at).format("hh:mm A") }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Input del mensaje -->
            <div class="message-input-wrapper p-3 border-top-subtle">
              <div class="input-group d-flex align-items-center">
                <input
                  type="text"
                  class="form-control chat-input"
                  v-model="message_input"
                  @keyup.enter="sendMessage(actualContact.id)"
                  placeholder="Escribe un mensaje..."
                />
                <button class="btn send-btn ml-2 d-flex align-items-center justify-content-center" @click="sendMessage(actualContact.id)">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transform: translate(-1px, 1px);">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Estado inicial sin chat seleccionado -->
          <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center p-5 text-center">
            <i class="mdi mdi-forum-outline mb-3" style="color: #A1A1AA; font-size: 56px;"></i>
            <h5 class="empty-chat-title mb-2">Selecciona una conversación</h5>
            <p class="empty-chat-sub">Elige un contacto de la lista para empezar a chatear</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echo from "laravel-echo";
import moment from "moment";
import { authGet } from "@/helpers/authStorage";

window.Pusher = require("pusher-js");

export default {
  props: {
    user: Object,
  },
  name: "message",
  data() {
    return {
      moment: moment,
      defaultAvatar: "https://cdn140.picsart.com/317925775068211.png?type=webp&to=min&r=240",
      actualContact: {
        photo: null,
      },
      actualMessageContent: [],
      chats: null,
      general: [],
      name_user: null,
      email: null,
      idOne: authGet("id_user"),
      session_user_name: `${authGet(
        "name_user"
      )} ${authGet("last_name_user")}`,
      idTwo: null,
      message_input: null,
      mensaje: "",
      newMessage: false,
      mostrar: true,
      contacts: [],
      contacts2: [],
      loading: true,
      cod1: null,
      cod2: null,
      selectedRole: 'Todos',
      selectedCourse: null,
      isDropdownOpen: false,
    };
  },
  computed: {
    uniqueCourses() {
      const allCourses = new Map();
      const addCourses = (contacts) => {
        contacts.forEach(c => {
          if (c.contexts) {
            c.contexts.forEach(ctx => {
              if (!allCourses.has(ctx.course_id)) {
                allCourses.set(ctx.course_id, ctx);
              }
            });
          }
        });
      };
      addCourses(this.contacts);
      addCourses(this.contacts2);
      return Array.from(allCourses.values());
    },
    selectedCourseItem() {
      if (!this.selectedCourse) return null;
      return this.uniqueCourses.find(c => c.course_id === this.selectedCourse);
    },
    headerContext() {
      if (!this.actualContact || !this.actualContact.contexts || this.actualContact.contexts.length === 0) {
        return null;
      }
      
      let primaryContext = this.actualContact.contexts[0];
      
      if (this.selectedCourse) {
        const found = this.actualContact.contexts.find(c => c.course_id === this.selectedCourse);
        if (found) primaryContext = found;
      }
      
      let text = `${primaryContext.role} en: ${primaryContext.course_title}`;
      if (this.actualContact.contexts.length > 1) {
        text += ` (+${this.actualContact.contexts.length - 1} más)`;
      }
      return text;
    },
    filteredContacts() {
      return this.filterContactsArray(this.contacts);
    },
    filteredContacts2() {
      return this.filterContactsArray(this.contacts2);
    }
  },
  methods: {
    filterContactsArray(contactsArray) {
      return contactsArray.filter(contact => {
        if (!contact.contexts || contact.contexts.length === 0) {
          if (this.selectedRole !== 'Todos' || this.selectedCourse) return false;
          return true;
        }

        // Filtro por Rol
        if (this.selectedRole !== 'Todos') {
          const hasRole = contact.contexts.some(ctx => ctx.role === this.selectedRole);
          if (!hasRole) return false;
        }

        // Filtro por Curso
        if (this.selectedCourse) {
          const hasCourse = contact.contexts.some(ctx => ctx.course_id === this.selectedCourse);
          if (!hasCourse) return false;
        }

        return true;
      });
    },
    onAvatarError(e) {
      if (e && e.target) {
        e.target.src = this.defaultAvatar;
      }
    },
    sendMessage(receiver_id) {
      if (!this.message_input || this.message_input.trim() === "") return;
      this.axios
        .post("messages/add", {
          receiver_id: receiver_id,
          message: this.message_input,
        })
        .then(() => {
          this.listActualContentMessage(this.idOne, receiver_id);
          this.message_input = "";
          this.listContacts();
          this.listContacts2();
        })
        .catch(() => {
          console.log("Error en enviar");
        });
    },

    cambiarChat(transmitter_id, receiver_id) {
      if (this.usersID()) {
        window.Echo.leave("chat." + this.usersID());
      }
      this.listActualContentMessage(transmitter_id, receiver_id);

      // Buscar el contacto tanto en chats activos como en nuevos contactos
      let selectedContact = this.contacts.find(contact => contact.id === receiver_id);
      if (!selectedContact) {
        selectedContact = this.contacts2.find(contact => contact.id === receiver_id);
      }
      if (selectedContact) {
        this.actualContact = selectedContact;
      }
    },

    listActualContentMessage(transmitter_id, receiver_id) {
      this.axios
        .post(`messages/content`, {
          transmitter_id: transmitter_id,
          receiver_id: receiver_id,
        })
        .then((r) => {
          this.actualMessageContent = r.data.data;
          this.idTwo = receiver_id;
        
          window.Echo = new Echo({
            broadcaster: "pusher",
            key: "PROMOLIDER2021",
            cluster: "mt1",
            wsHost: "crm.promolider.email",
            wsPort: 6001,
            wssPort: 443,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ["wss"],
            auth: {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, X-Auth-Token, Origin, Authorization",
              },
            },
          });
        
          window.Echo.channel("chat." + this.usersID()).listen(
            "MessageSentEvent",
            (e) => {
              console.log(e);
              this.actualMessageContent.push(e.message);
            }
          );
          
          for (let i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].id == receiver_id) {
              this.actualContact = this.contacts[i];
            }
          }
        
          if (transmitter_id > receiver_id) {
            this.cod1 = receiver_id;
            this.cod2 = transmitter_id;
          } else {
            this.cod2 = receiver_id;
            this.cod1 = transmitter_id;
          }
        })
        .catch((error) => {
          console.log("Error al cargar mensajes:", error);
          // ✅ MEJORA: Manejo de errores más específico
          if (error.response && error.response.status === 403) {
            console.error("No tienes permiso para ver estos mensajes");
          }
        });
    },

    async listContacts() {
      try {
        const response = await this.axios.get(`messages/listContacts`);

        // La nueva API devuelve un objeto con 'data' y 'total'
        const contactsData = response.data.data || [];

        this.contacts = contactsData;
        this.loading = false;

        // Seleccionar el primer contacto si existe
        if (contactsData.length > 0) {
          const firstContact = contactsData[0];
          this.actualContact = firstContact;
          this.listActualContentMessage(this.idOne, firstContact.id);
        }

        console.log('Contactos cargados:', contactsData.length);

      } catch (error) {
        console.error('Error al cargar contactos:', error);

        // Si no hay contactos (404), manejarlo graciosamente
        if (error.response && error.response.status === 404) {
          this.contacts = [];
          this.actualContact = null;
        }

        this.loading = false;
      }
    },

    listContacts2() {
      this.axios
        .get(`messages/listNewContacts/${this.idOne}`)
        .then((response) => {
          this.contacts2 = response.data;
        })
        .catch(() => {
          this.contacts2 = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    sendMessage2(id2) {
      this.axios
        .post("messages/sendNewMessage", {
          id: this.idOne,
          id2: id2,
        })
        .then(() => {
          this.listContacts();
          this.listContacts2();
        })
        .catch(() => {
          console.log("Error en enviar");
        });
    },

    usersID() {
      let ids;
      if (this.idOne > this.idTwo) {
        ids = this.idTwo + "" + this.idOne;
        return ids;
      } else {
        ids = this.idOne + "" + this.idTwo;
        return ids;
      }
    },
    mostrara() {
      this.mostrar = !this.mostrar;
    },
  },

  created() {
    this.listContacts();
    this.listContacts2();
  },
};
</script>

<style scoped>
@import "./style.css";
</style>